export const validateString = (string, length = 1) => {
  return string?.trim()?.length >= length;
};

export const validateObject = (obj) => {
  return typeof obj === "object" && obj !== null && Object.keys(obj).length > 0;
};

export const validateDate = (value) => {
  return value instanceof Date && !isNaN(value.getTime());
};

export const validateEmail = (value, length = 1) => {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailPattern.test(value) && value?.trim()?.length >= length;
};

export const validateNumber = (value) => {  
  if (typeof value === "string") {    
    return /^[0-9]+$/.test(value);
  }
  if (typeof value === "number") {
    return Number.isInteger(value) && value >= 0;
  }
  return false;
};
